export const TYPES_LOCATION = [
  ["loyer", "Location longue durée (> 30 jours) avec bail"],
  ["loyer_sans_bail", "Location longue durée (> 30 jours) sans bail"],
  ["plateforme", "Location courte durée (< 30 jours) Airbnb & Booking"],
  ["directe", "Location courte durée (< 30 jours) autres que Airbnb & Booking"],
];

export const typeLocation = (k) => (TYPES_LOCATION.find(([v]) => v === k) || [k, k])[1];

export const estLongue = (k) => k === "loyer" || k === "loyer_sans_bail";
